export const QUESTION_TYPES = {
  SINGLE_ANSWER: 'SINGLE_ANSWER_QUESTION',
  MULTIPLE_ANSWER: 'MULTIPLE_ANSWER_QUESTION',
  TEXT_ANSWER: 'TEXT_ANSWER_QUESTION',
};
